import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  MILLENNIUM_FOUND_NOTICE,
  MillenniumAllocation,
  MillenniumAllocationRow,
  millenniumAllocationRows
} from './composition-millennium';

@Component({
  selector: 'app-millennium-allocation-dialog',
  templateUrl: './millennium-allocation-dialog.component.html',
  styleUrls: ['./millennium-allocation-dialog.component.scss']
})
export class MillenniumAllocationDialogComponent {
  @Input() visible = false;
  @Input() detailMessage = '';
  @Output() visibleChange = new EventEmitter<boolean>();

  foundNotice = MILLENNIUM_FOUND_NOTICE;
  dialogStyle = { width: '36rem', maxWidth: '92vw' };
  rows: MillenniumAllocationRow[] = millenniumAllocationRows(null);

  @Input()
  set allocation(value: MillenniumAllocation | null) {
    this.rows = millenniumAllocationRows(value);
  }

  close(): void {
    if (!this.visible) {
      return;
    }
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
